import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapStateToProps} from '../../../../../helpers/reselectHelpers';
import {SettingsDevelopersApplicationServersUrl} from '../../../../../models/url/settingsUrlModel';
import {AppState} from '../../../../../store/appState';
import {
  makeGetLocalApplicationsServers,
  makeGetLocalApplicationsServersAsyncStatus,
} from '../../../../../store/data/localApplications/localApplicationsSelectors';
import {SettingsDevelopersApplicationConnectPage} from './settingsDevelopersApplicationConnectPage';

/*
 * Props.
 */

interface SettingsDevelopersApplicationConnectPageContainerProps {
  url: SettingsDevelopersApplicationServersUrl;
}

/*
 * Selectors.
 */

function getApplicationId(_state: AppState, props: SettingsDevelopersApplicationConnectPageContainerProps) {
  return props.url.applicationId;
}

function getServerId(_state: AppState, props: SettingsDevelopersApplicationConnectPageContainerProps) {
  return props.url.serverId;
}

const getServer = createSelector(
  [getServerId, makeGetLocalApplicationsServers(getApplicationId)],
  (serverId, servers) => {
    if (!servers) {
      return undefined;
    }
    return servers.find((server) => server.id === serverId);
  },
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<SettingsDevelopersApplicationConnectPageContainerProps>()(() => ({
  server: getServer,
  servers: makeGetLocalApplicationsServers(getApplicationId),
  serversAsyncStatus: makeGetLocalApplicationsServersAsyncStatus(getApplicationId),
}));

export const SettingsDevelopersApplicationConnectPageContainer = connect(mapStateToProps)(
  SettingsDevelopersApplicationConnectPage,
);
